export default __webpack_public_path__ + "static/media/63.1f3b355a.svg";